import axios from '@/utils/axios';


const runPersonVerification = async ( applicationId, deviceIdSessionToken ) => {

    try {

        const {
            data: {
                applicationRequiresDocV
            }
        } = await axios.post(`${process.env.BASE_URL}api/PersonVerification`, {
            applicationId,
            deviceIdSessionToken
        });

        return applicationRequiresDocV;

    } catch (error) {

        throw error;

    };

};

export default {

    runPersonVerification

};

export {

    runPersonVerification

};